import * as React from 'react';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

interface StarRatingProps {
  starCount: number;
}

const StarRating = ({ starCount }: StarRatingProps) => {

  const emptyStars = 5 - starCount;

  return (
    <div className='stars'>
      {
        Array.from({ length: starCount }).map((_, index) => (
          <StarIcon key={index} style={{ color: '#f9b403' }} />
        ))
      }
      {
        Array.from({ length: emptyStars }).map((_, index) => (
          <StarBorderIcon key={index} style={{ color: 'lightgray' }} />
        ))
      }
    </div>
  );
};

export default StarRating;